import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setQuery, setQueryError } from "../searchQuerySlice";

const SearchInput = () => {
  const dispatch = useDispatch();
  const { query, queryError } = useSelector((state) => state.searchQuery);

  const isValidInput = (text) => /^[a-zA-Z\s-]+$/.test(text.trim());

  return (
    <TextField
      label="Search Keyword"
      fullWidth
      variant="outlined"
      value={query}
      onChange={(e) => {
        dispatch(setQuery(e.target.value));
        dispatch(setQueryError(""));
      }}
      onBlur={() => {
        if (!query.trim()) {
          dispatch(setQueryError("Search keyword is required"));
        } else if (!isValidInput(query)) {
          dispatch(setQueryError("Invalid search keyword"));
        } else {
          dispatch(setQueryError(""));
        }
      }}
      placeholder="e.g. Italian, Vegan"
      error={!!queryError}
      helperText={queryError}
      sx={{
        mb: 3,
        "& .MuiOutlinedInput-root": {
          borderRadius: 4,
          backgroundColor: "rgba(255,255,255,0.9)",
          "& fieldset": {
            borderColor: "rgba(14,165,233,0.25)",
          },
          "&:hover fieldset": {
            borderColor: "secondary.main",
          },
          "&.Mui-focused fieldset": {
            borderWidth: 2,
            borderColor: "primary.main",
          },
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: "primary.main",
        },
      }}
    />
  );
};

export default SearchInput;
